export default "__VITE_ASSET__L1LdTaP6__"